export default __webpack_public_path__ + "static/media/telefon_main_.d7b3a12c.png";